export enum RateCalculationType {
    DEFAULT = "DEFAULT",
    RATE_AMOUNT_ONLY = "RATE_AMOUNT_ONLY",
}

export type RateAgreementTenantConfiguration = {
    enableDynamicSettlementFee: boolean;
    rateCalculationType: RateCalculationType;
    numberOfOutstandingRatesEnabled: boolean;
    enableUserNameVerificationForRateagreementCreation: boolean;
};
